import { FC, useRef } from 'react'
import styled from 'styled-components'
import { useSelectionPopoverContext } from '../SelectionPopover'
import { CoverLetterContentNode, CoverLetterNodeType } from './index'

interface ScrapHighlightNodeProps {
  node: CoverLetterContentNode
}

export const ScrapHighlightNode: FC<ScrapHighlightNodeProps> = ({
  children,
  node,
}) => {
  const markRef = useRef<HTMLElement | null>(null)
  const { openPopover } = useSelectionPopoverContext()

  const handleClick = () => {
    const mark = markRef.current
    if (!mark) {
      return
    }

    const rect = mark.getBoundingClientRect()

    openPopover({
      selectionRect: rect,
      scrapID: node.id,
      selectionText: mark.innerText,
    })
  }

  return (
    <StyledMark ref={markRef} onClick={handleClick}>
      {children}
    </StyledMark>
  )
}

const StyledMark = styled.mark`
  background-color: #ffcccc;
  cursor: pointer;
`

export function buildScrapHighlightNode(
  id: string,
  childrenNodeList: CoverLetterContentNode[],
): CoverLetterContentNode {
  return {
    id,
    type: CoverLetterNodeType.COMPONENT,
    wrapper: 'ScrapHighlightNode',
    childrenNodeList,
  }
}
